import {createDeepSlice} from "./base";

export interface IDebug {
    showAltitude: boolean
    showTileImage: boolean
}

const slice = createDeepSlice<IDebug>("debug", {
    showAltitude: false,
    showTileImage: false
});

export const {remove, update} = slice.actions;
export default slice.reducer;